export function closeLightbox() {
  return {
    type: 'DROPZONE_MULTI_FILE::CLOSE_LIGHT_BOX',
  };
}

export function openLightbox(currentImage) {
  if (!currentImage) {
    currentImage = 0;
  }
  return {
    type: 'DROPZONE_MULTI_FILE::OPEN_LIGHT_BOX',
    currentImage: currentImage,
  };
}

export function setLightboxImage(currentImage) {
  return {
    type: 'DROPZONE_MULTI_FILE::SET_LIGHT_BOX_IMAGE',
    currentImage: currentImage,
  };
}
